import React from 'react';


import { Button } from 'components/core/Button';
import { Image } from 'components/core/Image';
import { Paragraph } from 'components/core/Typography';

import podsImage from 'assets/images/promos/pods.jpg';
import './PODSPromo.scss';


export function PODSPromo() {
	return (
		<div className="pods-promo">
			<Image
				className="pods-image"
				src={podsImage}
			/>
			<div className="pods-content">
				<Paragraph size="large" color="white">
					Save up to 10%
				</Paragraph>
				<Paragraph color="white" last>
					on local or cross-country moves with PODS using the code <strong>SPAREFOOT</strong>
				</Paragraph>
			</div>
			<div className="pods-button-container">
				<Button
					href="https://www.pods.com/partners/sparefoot"
					target="_blank"
					rel="noreferrer noopener nofollow"
					className="pods-button"
				>
					Learn More
				</Button>
			</div>
		</div>
	);
}

export default PODSPromo;
